export const sources={};export const img={src:"__VITE_ASSET__i2ywl_YzKp2MjtOEr7ngzA__",w:640,h:640};export default{sources:sources,img:img};